export const DEFAULT_NOT_FOUND_MSG = 'Data Not Found';
